import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WeixinPayOrderPage } from './weixin-pay-order';

@NgModule({
  declarations: [
    WeixinPayOrderPage,
  ],
  imports: [
    IonicPageModule.forChild(WeixinPayOrderPage),
  ],
})
export class WeixinPayOrderPageModule {}



// WEBPACK FOOTER //
// ./src/pages/weixin-pay-order/weixin-pay-order.module.ts